import React from "react";

export default function Container({ children }) {
    return (
        <div style={{
            maxWidth: 400,
            margin: "auto",
        }}>
            {children}
        </div>
    );
}
